<!--
 * @Description: 调代课申请 添加
 * @Author: PF
 * @Date: 2023-07-21 11:10:39
 * @LastEditors: PF
 * @LastEditTime: 2023-08-03 16:14:31
-->
<template>
  <div>
    <el-dialog class="w600 h500" :model-value="openAdd" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">添加</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openAdd', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="学期" prop="xqid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.xqid" filterable clearable>
                <el-option v-for="item in xqData" :key="item.id" :label="item.xqmc" :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="调代课类型" prop="tdklx" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.tdklx" filterable clearable>
                <el-option v-for="item in tdklxData.list" :key="item.value" :label="item.name" :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="调代课时间段" prop="kssj" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-date-picker v-model="tdksd" type="datetimerange" range-separator="-" start-placeholder="开始时间" end-placeholder="结束时间" value-format="YYYY-MM-DD HH:mm" format="YYYY-MM-DD HH:mm" :default-time="defaultTime" @change="tdksdChange"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="原因" prop="yy" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input v-model="ruleForm.yy" :rows="6" type="textarea" resize="none"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openAdd', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import { submitForm, closeWindow, loadSelect } from '@/api/common.js'
import { gettdkzt } from '@/utils/meiju'

const props = defineProps({ openAdd: { type: Boolean, required: true } })
const emits = defineEmits(['update:openAdd', 'ReturnData'])

const defaultTime = ref([new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 2, 1, 23, 59, 59)])

const ruleFormRef = ref(null)
const ruleForm = ref({})

const xqData = ref() // 加载 学期 下拉框

const tdksd = ref([]) // 调代课时段
// 拆分时间
const tdksdChange = () => {
  if (tdksd.value) {
    ruleForm.value.kssj = tdksd.value[0]
    ruleForm.value.jssj = tdksd.value[1]
  }
}
const tdkztData = ref({ list: [] }) // 加载 调代课状态 下拉框
const tdklxData = ref({ list: [] }) // 加载 调代课类型 下拉框
watch(
  () => props.openAdd,
  () => {
    if (props.openAdd) {
      tdkztData.value = gettdkzt()
      loadSelect({ url: '/api/v2/jiaowu/tiaodaikeshenqing/tiaodaikeleixing', data: tdklxData })
      loadSelect({
        url: '/api/v2/pdp/xueqi/list',
        data: xqData,
        order: 'sx',
        sort: 'asc',
        loadSuccess: function (res) {
          if (ruleForm.value.xqid === undefined) {
            if (res.data.length) {
              res.data.forEach((item) => {
                if (item.sfdqxq === true) {
                  ruleForm.value.xqid = item.id
                }
              })
            }
          }
        }
      })
    }
  },
  { deep: true, immediate: true }
)

// 提交
const submit = async () => {
  submitForm({
    url: '/api/v2/jiaowu/tiaodaikeshenqing',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function (res) {
      closeWindow('openAdd', emits, true)
    }
  })
}
</script>
